import {
  Button,
  Dialog,
  DialogActions,
  DialogContent
} from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { defaultTo } from 'lodash';
import React from 'react';
import {
  fetchEnd,
  fetchStart,
  showNotification,
  SaveButton
} from 'react-admin';
import { FormSpy } from 'react-final-form';
import { connect } from 'react-redux';
import UserMailApi from '../../core/apis/UserMailApi';
import DialogTitleWithCloseButton from '../../core/components/DialogTitleWithCloseButton';
import { getIcError } from '../../core/providers/utils';
import EmailForm from '../resourceuploads/uploadsteps/emailDialog/EmailForm';
import EmailPreviewDialog from './EmailPreviewDialog';
import CustomSimpleForm from '../../core/components/form/CustomSimpleForm';
const styles = {
  paperWidthFalse: {
    height: 'inherit'
  },
  dialogContent: {
    padding: '0px'
  },
  secondaryButton: {
    border: '1px solid #E0E0E0',
    '& span': {
      padding: 0
    },
    marginLeft: '10px'
  },
  leftWrapper: {
    flexGrow: 1
  },
  testButton: {
    border: '1px solid #E0E0E0',
    '& span': {
      padding: 0
    }
  },
  button: {
    '& span': {
      padding: 0
    }
  },
  form: {
    height: 'inherit',
    '& > div': {
      padding: '0px !important',
      height: 'inherit'
    },
    '& > div > div': {
      display: 'flex',
      flexDirection: 'column',
      height: 'inherit'
    }
  }
};

const splitEmails = value => {
  if (value && value.length > 0) {
    const emailParts = value.split(';');
    const mailDto = [];
    for (var i = 0; i <= emailParts.length - 1; i++) {
      var emailAddress = emailParts[i].trim();
      if (emailAddress !== '') {
        mailDto.push({
          name: null,
          address: emailAddress
        });
      }
    }
    return mailDto;
  }
  return [];
};

class UserEmailDialog extends React.Component {
  state = {
    submitting: false,
    showDistributionListPreviewEmailDialog: false
  };

  getBase64 = file => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function() {
        resolve(reader.result);
      };
    });
  };

  onSubmit = async values => {
    if (!values.isTestEmail) {
      this.setState({ submitting: true });
    }
    const { showNotification, handleClose } = this.props;

    const attachments = await defaultTo(values.attachments, []).map(
      async item => {
        let base64Content = await this.getBase64(item.rawFile);
        // base64Content have form of: "mimeType;base64,fileCodedInBase64"
        let splitedRawFileData = base64Content.split(',');
        let base64FileContent = splitedRawFileData[1];
        return {
          content: base64FileContent,
          mimeType: item.type,
          fileName: item.title,
          disposition: null,
          contentId: null
        };
      }
    );

    const mailData = {
      from: {
        fromAddress: {
          name: values.alias,
          address: values.from
        },
        replyToAddress: {
          name: null,
          address: values.aliasTo
        },
        rememberEmailAddressAlias: values.rememberMe
      },
      to: splitEmails(values.userEmail),
      cc: splitEmails(values.cc),
      bcc: splitEmails(values.bcc),
      subject: values.subject,
      msgBody: values.msgBody,
      attachments: await Promise.all(attachments),
      isTestEmail: values.isTestEmail
    };
    try {
      await UserMailApi.create(mailData);
      if (!values.isTestEmail) {
        handleClose();
      }
      showNotification('Emails were sent successfully', 'info');
    } catch (e) {
      showNotification('ra.notification.server', 'error', {
        messageArgs: { message: getIcError(e) }
      });
    } finally {
      this.setState({ submitting: false });
    }
  };

  showDistributionListPreviewEmailDialog = () => {
    this.setState(({ showDistributionListPreviewEmailDialog }) => {
      return {
        showDistributionListPreviewEmailDialog: !showDistributionListPreviewEmailDialog
      };
    });
  };

  render() {
    const {
      open,
      handleClose,
      classes,
      cc,
      variableType = 'contact',
      userProfile,
      record
    } = this.props;
    const { submitting, showDistributionListPreviewEmailDialog } = this.state;
    return (
      <CustomSimpleForm
        toolbar={null}
        resource="sendmail"
        variant="standard"
        save={this.onSubmit}
        className={classes.form}
        initialValues={{
          cc:
            cc === undefined || cc === null || cc.length === 0
              ? undefined
              : cc.toString().replaceAll(',', ';'),
          userEmail: record.email,
          rememberMe: false
        }}
        margin="normal"
        keepDirtyOnReinitialize={false}
      >
        <FormSpy subscription={{ values: true, pristine: true }}>
          {formprops => {
            return (
              <Dialog
                open={open}
                aria-label="Edit Email"
                maxWidth={false}
                onClose={(event, reason) => {
                  if (reason === 'backdropClick') return null;
                  handleClose();
                }}
                disableEnforceFocus={true}
                classes={{
                  paperWidthFalse: classes.paperWidthFalse // class name, e.g. `classes-nesting-root-x`
                }}
              >
                <DialogTitleWithCloseButton onClose={handleClose}>
                  Edit Email
                </DialogTitleWithCloseButton>
                <DialogContent>
                  <EmailForm
                    variant="standard"
                    formprops={formprops}
                    userEmail={record.email}
                    attachments={true}
                    variableType={variableType}
                    userProfile={userProfile}
                  />
                  <EmailPreviewDialog
                    {...formprops}
                    title=" "
                    showDialog={showDistributionListPreviewEmailDialog}
                    handleDialogToggle={
                      this.showDistributionListPreviewEmailDialog
                    }
                    record={record}
                  />
                </DialogContent>
                <DialogActions
                  style={{ borderTop: `1px solid rgba(0, 0, 0, 0.12)` }}
                >
                  <div className={classes.leftWrapper}>
                    <Button
                      onClick={() => {
                        formprops.values.isTestEmail = true;
                        formprops.form.submit();
                      }}
                      variant="outlined"
                      color="primary"
                      className={classes.testButton}
                    >
                      Send Test Email
                    </Button>
                    <Button
                      variant="outlined"
                      color="primary"
                      className={classes.secondaryButton}
                      onClick={this.showDistributionListPreviewEmailDialog}
                    >
                      Preview Email
                    </Button>
                  </div>
                  <SaveButton
                    saving={submitting}
                    handleSubmitWithRedirect={() => {
                      formprops.values.isTestEmail = false;
                      formprops.form.submit();
                    }}
                    color="primary"
                    disabled={submitting}
                    variant="contained"
                    className={classes.button}
                    label={'Send Email'}
                    icon={<></>}
                  />
                </DialogActions>
              </Dialog>
            );
          }}
        </FormSpy>
      </CustomSimpleForm>
    );
  }
}

const mapDispatchToProps = {
  showNotification,
  fetchStart,
  fetchEnd
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(UserEmailDialog));
